export default __webpack_public_path__ + "static/media/double_click.b4787df3.gif";